import { render, staticRenderFns } from "./FeatureOptionsManager.vue?vue&type=template&id=70d1b47d"
import script from "./FeatureOptionsManager.vue?vue&type=script&lang=js"
export * from "./FeatureOptionsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports